export default "__VITE_ASSET__$k3SEQm9__"